import React from 'react';
import { useSession } from 'next-auth/react';
import { SpinnerIcon } from '@avila-tek/ui/src';
import { useRouter } from 'next/router';

function Auth({ children }) {
  const router = useRouter();
  const { status } = useSession({ required: true });

  // React.useEffect(() => {
  //   if (status === 'authenticated' && !router.pathname.includes('/app')) {
  //     router.push('/sign-in');
  //   }
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [status]);

  if (status === 'loading') {
    return (
      <div className="w-full h-[70vh] flex  opacity-70 z-30">
        <SpinnerIcon className="m-auto w-24 h-24 text-gray-200 animate-spin  fill-purple-300" />
        <span className="sr-only">Loading...</span>
      </div>
    );
  }

  return children;
}

export default Auth;
